<template>
  <div>
    <v-container fluid class="d-flex pa-0 fullHeight">
      <AsideBar
        :items="asidebar.items"
        :title="asidebar.title"
        @changed="changed"
      ></AsideBar>
      <v-container fluid class="scrollableContent pa-0">
        <v-container class="container-custom px-6">
          <Breadcrumbs
            :title="$t('modules.cards_configuration.table.breadcrumbs.title')"
            :description="
              $t('modules.cards_configuration.table.breadcrumbs.description')
            "
          >
            <Button
              v-if="true"
              @clicked="newCardConfiguration"
              icon="mdi-plus"
              :text="$t('actions.new_female')"
              :disabled="!canCreate"
              depressed
            ></Button>
          </Breadcrumbs>
          <v-row justify="center">
            <v-col sm="12" class="viewSpaces">
              <SuperTable
                :headers="headers"
                :configs="configs"
                :clear-selected="clearSelected"
                :pageCount="pagination.pagesAmount"
                :page="pagination.page"
                :permissions="{
                  read: canRead,
                  update: canUpdate,
                  delete: canDelete,
                }"
                :total-items="totalItems"
                @searchAction="searchAction"
                :sortBy.sync="sort.sortBy"
                :sortDesc.sync="sort.sortDesc"
                @input-pagination="onInputPagination"
                @length-pagination-change="onLengthPaginationChange"
                @bulk-delete="
                  (configs) => {
                    bulkDeletePopUp(configs);
                  }
                "
                @deleteCardConfig="(id) => deleteCardConfigPopUp(id)"
                @updateUser="
                  (id) => {
                    updateCardConfig(id);
                  }
                "
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-container>
  </div>
</template>
<script>
import AsideBar from '@/components/AsideBar/AsideBar';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import SuperTable from '../Components/SuperTable/SuperTable';
import Button from '@/components/Button/Button';
import { mapGetters } from 'vuex';
import { $cardsConfiguration } from '../Services';

export default {
  name: 'CardsConfigurationTable',
  components: {
    AsideBar,
    Breadcrumbs,
    Button,
    SuperTable,
  },
  data() {
    return {
      clearSelected: '',
      asidebar: {
        title: this.$t('modules.cards_configuration.table.filters.title'),
        items: [
          {
            name: this.$t('modules.cards_configuration.table.filters.account'),
            filters: [
              {
                type: 'autocomplete',
                name: 'Cuenta',
                field: 'account',
                items: [],
                condition: 'gt',
                value: null,
                clearable: true,
                isCalendarOpen: false,
                dataFiltered: 123,
              },
            ],
          },
          {
            name: this.$t('modules.cards_configuration.table.filters.bank'),
            filters: [
              {
                type: 'autocomplete',
                name: 'Banco',
                field: 'bank',
                items: [],
                condition: 'gt',
                value: null,
                clearable: true,
                isCalendarOpen: false,
                dataFiltered: 123,
              },
            ],
          },
          {
            name: this.$t('modules.cards_configuration.table.filters.card'),
            filters: [
              {
                type: 'autocomplete',
                name: 'Tarjeta',
                field: 'card',
                items: [],
                condition: 'gt',
                value: null,
                clearable: true,
                isCalendarOpen: false,
                dataFiltered: 123,
              },
            ],
          },
          {
            name: this.$t('modules.cards_configuration.table.filters.dates'),
            filters: [
              {
                name: 'Desde',
                type: 'date',
                value: null,
                isCalendarOpen: false,
              },
              {
                name: 'Hasta',
                type: 'date',
                value: null,
                isCalendarOpen: false,
              }
            ],
          },
          {
            name: this.$t('modules.cards_configuration.table.filters.interests'),
            filters: [
              {
                name: 'Tiene intereses',
                type: 'check',
                value: true,
                items: [],
                dataFiltered: '',
              },
              {
                name: 'No tiene intereses',
                type: 'check',
                value: true,
                items : [],
                dataFiltered: '',
                mandatory: false,
              }
            ],
          },
        ],
      },
      headers: [
        {
          text: this.$t('modules.cards_configuration.table.headers.account'),
          value: 'account',
          sort: () => 0
        },
        {
          text: this.$t('modules.cards_configuration.table.headers.bank'),
          value: 'bank',
          sort: () => 0
        },
        {
          text: this.$t('modules.cards_configuration.table.headers.card'),
          value: 'card',
          sort: () => 0
        },
        {
          text: this.$t('modules.cards_configuration.table.headers.card_type'),
          value: 'type'
        },
        {
          text: this.$t('modules.cards_configuration.table.headers.from'),
          value: 'from',
          sortable: true,
          sort: () => 0
        },
        {
          text: this.$t('modules.cards_configuration.table.headers.until'),
          value: 'to',
          sortable: true,
          sort: () => 0
        },
        {
          text: this.$t('modules.cards_configuration.table.headers.interests'),
          value: 'interests',
          sort: () => 0
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      totalItems: null,
      pagination: {
        limit: 20,
        page: 1,
        pageAmount: 1,
      },
      sort: {
        sortBy: '',
        sortDesc: false,
      },
      loading: false,
      configs: [],
      rawConfigs: [],
    };
  },
  computed: {
    canRead() {
      return this.$permissions.portaladministrativo.prices.cards_configuration.READ;
    },
    canCreate() {
      return this.$permissions.portaladministrativo.prices.cards_configuration.CREATE;
    },
    canUpdate() {
      return this.$permissions.portaladministrativo.prices.cards_configuration.UPDATE;
    },
    canDelete() {
      return this.$permissions.portaladministrativo.prices.cards_configuration.DELETE;
    },
    ...mapGetters({
      configurationValues: 'settings/getAllCurrentValues',
      configurationOptions: 'settings/getAllOptions',
    }),
  },
  methods: {
    onInputPagination(event) {
      this.pagination.page = event;
      this.fetchData();
    },
    onLengthPaginationChange(event) {
      this.pagination = {
        page: 1,
        limit: event,
        pagesAmount: 1,
      };
      this.fetchData();
    },
    searchAction(data) {
      this.pagination.page = 1;
      this.search = data;
      this.fetchData();
    },
    changed(parent, filter, value) {
      this.asidebar.items[parent].filters[filter].value = value;

      // validación de fechas
      const dateFilters = this.asidebar.items[parent].filters;
      const validDates = this.validateDates(dateFilters, filter);
      if (validDates) {
        this.fetchData();
      } else {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('modules.cards_configuration.table.error_message.dates_error'),
          content: [
            {
              value: 'La fecha \'Hasta\' debe ser mayor a la fecha \'Desde\'.',
            }
          ],
          actionPrimary: { text: 'Aceptar', callback() {} },
          icon: { color: 'warning', name: 'mdi-eye-off-outline' },
          color: 'primary'
        });
      }
    },
    bulkDeletePopUp(cardConfigs) {
      this.$store.dispatch('commons/openPopUp', {
        title: this.$t('modules.cards_configuration.table.message.title'),
        content: cardConfigs.map(cardConfig => ({
          value: cardConfig.name
        })),
        actionPrimary: {
          text: this.$t('modules.cards_configuration.table.message.deleteAction'),
          callback: async () => {
            try {
              await this.bulkDelete(cardConfigs);
            } catch {
              this.$store.dispatch('commons/openPopUp', {
                title: this.$t(
                  'modules.cards_configuration.table.error_message.bulk_delete_message'
                ),
                content: cardConfigs.map(cardConfig => ({
                  value: cardConfig.name
                })),
                actionPrimary: { text: 'Aceptar', callback() {} },
                icon: { color: 'error', name: 'mdi-close' },
                color: 'primary'
              });
            }
          }
        },
        actionSecondary: {
          text: this.$t('modules.cards_configuration.table.message.cancelAction'),
          callback() {}
        },
        icon: { color: 'error', name: 'mdi-delete' },
        color: 'primary'
      });
    },
    
    async bulkDelete(cardConfigs) {
      const itemsForDelete = cardConfigs.map(cardConfig => {
        return { id: cardConfig.id };
      });
      try {
        await $cardsConfiguration.bulkDelete(itemsForDelete);
      } finally {
        this.fetchData();
      }
    },
    deleteCardConfigPopUp(id) {
      const cardConfig = this.configs.find(
        cardConfig => cardConfig.id == id
      );
      this.$store.dispatch('commons/openPopUp', {
        title: '¿Esta seguro de eliminar?',
        content: [
          {
            value: cardConfig.description
          }
        ],
        actionPrimary: {
          text: 'Aceptar',
          callback: () => this.deleteCardConfig(id)
        },
        actionSecondary: {
          text: 'Cancelar',
          callback() {}
        },
        icon: { color: 'error', name: 'mdi-delete' },
        color: 'primary'
      });
    },
    async deleteCardConfig(id) {
      try {
        await $cardsConfiguration.delete(id);
        this.configs = this.configs.filter(
          cardConfig => cardConfig.id !== id
        );
      } finally {
        this.fetchData();
      }
    },
    updateCardConfig(id) {
      if (this.canUpdate) this.$router.push(`cards-configuration/update/${id}`);
    },
    newCardConfiguration() {
      if (this.canCreate) this.$router.push('/cards-configuration/create');
    },
    async fetchData() {

      this.loading = true;
      let sortCol = 'name'
      switch (this.sort.sortBy) {
        case 'name':
        default:
          sortCol = 'account.name';
          break;
        case  'bank':
          sortCol = 'bank.issuer';
          break;
        case 'card':
          sortCol = 'card.name';
          break;
        case 'from':
          sortCol = 'from';
          break;
        case 'to':
          sortCol = 'to';
          break;
        case 'interests':
          sortCol = 'interest';
          break;
      }
      try {

        const params = {
            page: this.pagination.page == 0 ? this.pagination.page = 0 : this.pagination.page - 1,
            size: this.pagination.limit,
            search: this.search,
            orderBy: sortCol,
            orientation: this.sort.sortDesc ? 'desc' : 'asc',
        }

        const filterParams = {}

        if (this.asidebar.items[0].filters[0].value) {
          filterParams.accountId = this.asidebar.items[0].filters[0].value;
        }

        if (this.asidebar.items[1].filters[0].value) {
          filterParams.bankId = this.asidebar.items[1].filters[0].value;
        }

        if (this.asidebar.items[2].filters[0].value) {
          filterParams.cardId = this.asidebar.items[2].filters[0].value;
        }

        if (this.asidebar.items[3].filters[0].value) {
          filterParams.fromDate = this.asidebar.items[3].filters[0].value;

        }

        if (this.asidebar.items[3].filters[1].value) {
          filterParams.toDate = this.asidebar.items[3].filters[1].value;
        }

        if (this.asidebar.items[4].filters[0].value) {
          if (!this.asidebar.items[4].filters[1].value) {
            filterParams.interests = true;
          }
        }

        if (this.asidebar.items[4].filters[1].value) {
          if (!this.asidebar.items[4].filters[0].value) {
            filterParams.interests = false;
          }
        }

        const configs = await $cardsConfiguration.filter(filterParams, {params});
        this.configs = configs.data.content.map(config => {
          return {
            id: config.id,
            account: config.account.name,
            bank: config.bank.issuer,
            card: config.card.name,
            type: config.card.type.meaning,
            from: config.from,
            to: config.to,
            interest: config.interest,
          }
        });
        this.filteredItems = this.configs;
        this.totalItems = configs.data.totalElements;
        this.pagination.pagesAmount = configs.data.totalPages; //no devuelve este valor
        this.rawConfigs = JSON.parse(JSON.stringify(this.configs));
      } catch (error) {
        this.configs = [];
        this.pagination.page = 1;
        this.pagination.pagesAmount = 1;
        this.totalItems = 0;
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async getCards() {
      try {
        const res = await $cardsConfiguration.getCards();
        res.data.forEach(card => {
          this.asidebar.items[2].filters[0].items.push({text: card.name, value: card.id})
        });
      } catch (error) {
        return error;
      }
    },
    async getAccounts() {
      try {
        const res = await $cardsConfiguration.getAccounts(false);
        res.data.forEach(account => {
          this.asidebar.items[0].filters[0].items.push({text:account.name, value: account.id})
        });
      } catch (error) {
        return error;
      }
    },
    async getBanks() {
      try {
        const res = await $cardsConfiguration.getBanks();
        res.data.forEach(bank => {
          this.asidebar.items[1].filters[0].items.push({text: bank.issuer, value: bank.id})
        });
      } catch (error) {
        return error;
      }
    },
    validateDates(dateFilters, filter) {
      if (dateFilters[filter].name === 'Desde' || dateFilters[filter].name === 'Hasta') {
        if (dateFilters[0].value && dateFilters[1].value) {
          return (dateFilters[1].value > dateFilters[0].value);
        }
      }
      return true;
    }
  },
  async mounted () {
    await this.getAccounts();
    await this.getBanks();
    await this.getCards();
    this.fetchData();
  },
  watch: {
    sort: {
      handler(){
        this.fetchData();
      },
      deep: true
    }
  }
};
</script>
